export default __webpack_public_path__ + "10a054abe8a2c5f32377f15b3c29edb6.png";